import React from 'react';
import { useLocation } from 'react-router-dom'
import { Model, StylesManager } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/defaultV2.css';
import { useHistory } from "react-router"

StylesManager.applyTheme('defaultV2');

/**
 * Renders form template viewer parent component. Contains the form renderer (survey js component).
 * 
 * @returns 
 */
export function FormViewer() {
  const location = useLocation()
  const { json, name } = location.state
  const history = useHistory()

  let model = new Model(json);
  model.mode = "display";

  return (
    <div className="add-new-referral-container">
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="add-new-text">{name}</div>
      </div>
      <Survey model={model} />
    </div>
  );
}
